/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum OrderDiscountFrequencyQualifier {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY'
}

export function OrderDiscountFrequencyQualifierFromJSON(json: any): OrderDiscountFrequencyQualifier {
    return OrderDiscountFrequencyQualifierFromJSONTyped(json, false);
}

export function OrderDiscountFrequencyQualifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDiscountFrequencyQualifier {
    return json as OrderDiscountFrequencyQualifier;
}

export function OrderDiscountFrequencyQualifierToJSON(value?: OrderDiscountFrequencyQualifier | null): any {
    return value as any;
}

